import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['picker', 'text'];

  connect() {
    this.updatePicker();
  }

  validate(event) {
    const value = event.target.value;

    if (!value.match(/^#[0-9a-fA-F]{0,6}$/)) {
      event.preventDefault();
      event.target.value = value.slice(0, -1);
    }
  }

  updateText() {
    this.textTarget.value = this.pickerTarget.value;
  }

  updatePicker() {
    if (this.textTarget.value.match(/^#[0-9a-fA-F]{6}$/)) {
      this.pickerTarget.value = this.textTarget.value;
    }
  }
}
